const imgVote = require('./vote.svg');
const waves = require('./waves.svg');
const avatar = require('./avatar.jpeg');

export {
    imgVote,
    waves,
    avatar
}